export default "__VITE_ASSET__waaeu8Zq__"